(function() {
  'use strict';
  angular.module('irricrops')
  .directive("tabs", [ function(){
    return{
      restrict : "E",
      templateUrl:"shared/tabs/tabs.tmpl.html",
      scope:{
        index:'=',
        api:'=',
      },
      controller:"tabCtrl",
      controllerAs: "tctrl"
    };
  }])
  .controller("tabCtrl",['Config', 'global' ,'$scope', 'CONSTANTES','$state',
      function (Config,global,  $scope, CONSTANTES, $state) {
      //this.tabs = $scope.tabs;
        var vm              = this;
            vm.tabs         = global.tabs;
            vm.index        = $scope.index;
            vm.title        = global.title;  //$scope.globalTitle;
            vm.itemSelected = null;
            vm.fromMenu     = false;
            vm.limit        = 5;

    if (angular.isUndefined($scope.api)) {
      $scope.api = {};
    }


    function StringIsNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

        vm.openMenu = function($mdMenu, ev) {
          $mdMenu.open(ev);
        };



      /**
       * recibe un item y verifica si tiene
       * permisos sobre ese config
       *
       * return boolean
       *
       */
      var tabPermissions = function(item){
        if (item === null) {
          return false;
        }
        var hasConfig     = true;
        var hasPermission = true;
        var hasMode       = false;
        if (angular.isDefined(Config.vinedo) && angular.isDefined(Config.user)) {
          if(angular.isDefined(item.visible)){

            //hasConfig = item.visible.config ? parseInt(Config.vinedo[item.visible.config]) : true ;

            if (item.visible.config) {
              if (Config.vinedo[item.visible.config]) {
                if (StringIsNumber()) {
                    hasConfig = parseInt(Config.vinedo[item.visible.config]);
                }else if (typeof(Config.vinedo[item.visible.config]) === "boolean") {
                    hasConfig = Config.vinedo[item.visible.config];
                }
              }else{
                hasConfig = false;
              }
            }else{
              hasConfig = true;
            }

            if (item.visible.permission) {
              if (angular.isDefined(Config.user[item.visible.permission])) {
                  hasPermission = Config.user[item.visible.permission];
              }else{
                hasPermission = false;
              }
            }else{
              hasPermission = true;
            }


            if (angular.isDefined(item.visible.mode)) {
              if(CONSTANTES.MODES[item.visible.mode] == global.dynamicTheme){
                hasMode = true;
              }else{
                hasMode = false;
              }
            }else{
              hasMode = true;
            }

          }
        }else{
          hasConfig = false;
          hasPermission = false;
          hasMode= false;
        }
        return hasConfig && hasPermission && hasMode;
      };


      /**
       * obtiene el primer item de las tabs
       * a la que el usuario actual tiene permisos
       *
       * return object item
       */
      var getFirstValidItem = function () {
        var firstItem = null;
        angular.forEach(vm.tabs, function(tab, key) {
          if (firstItem === null) {
            if (tabPermissions(tab)) {
              firstItem = tab;
            }
          }
        });
        return firstItem;
      };
      $scope.api.getFirstValidItem = getFirstValidItem;


      /**
       * segun un nombre de state, devuelve
       * el item, de la lista actual
       * de tabs
       *
       * return object item
       */
      var getItemFromStateName = function (state) {
        var item = null;
        angular.forEach(vm.tabs, function(tab){
          if (tab.state == state) {
            item = tab;
          }
        });
        return item;
      };

      $scope.api.getItemFromStateName = getItemFromStateName;


      /**
       * devuelve el permiso de un estado
       * de la lista actual de tabs
       *
       * return boolean
       */
      var statePermissions = function(state) {
        return tabPermissions(getItemFromStateName(state));
      };
      $scope.api.statePermissions = statePermissions;

    /**
     * recrea las tabs en la vista
     */
    vm.renderTabs = function () {
      var newTabs = [];
      angular.forEach(vm.tabs, function(tab, k) {
        if (tabPermissions(tab)) {
          tab.idTab = newTabs.length; //posicion del dato
          newTabs.push(tab);
        }
      });
      vm.newTabs = newTabs;
    };

    vm.renderTabs();

    /**
     * refresca las tabs en la vista, desde
     * los datos globales
     */
    $scope.api.refreshTabs = function () {
      vm.tabs = global.tabs;
      vm.title = global.title;
      vm.renderTabs();
    };

   /**
    * selecciona un tab segun state
    *
    * return item
    */
    $scope.api.selectState = function (state) {
      var tabSelected = null;
      vm.fromMenu = false;

      angular.forEach(vm.newTabs, function(tab, key) {
        if (tab.state == state) {
          tabSelected = tab;
        }
      });
      if (tabSelected !== null) {
        vm.index = tabSelected.idTab;
        vm.itemSelected = tabSelected;
        vm.fromMenu = vm.newTabs.indexOf(tabSelected) >= vm.limit;
      }
      return tabSelected;
    };

    vm.selectTab = function(tab, fromMenu) {
        vm.itemSelected = tab;
        vm.index = tab.idTab;
        vm.fromMenu = fromMenu || false;
        tab.loading = true;
        $state.go(tab.state, {
          id: tab.itemId
        }).then(function(){
          tab.loading = false;
        });
    }



  }]);
}());
